import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthenticationService} from "./authentication.service";
import {ApiPathsService} from "../api-paths.service";
import {map} from "rxjs/operators";


@Injectable({providedIn: 'root'})
export class ApiRestService {
  constructor(
    private http: HttpClient,
  ) { }
  options() {
    return {headers: this.headers()};
  }
  headers() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
       Authorization: `Bearer ${JSON.parse(localStorage.getItem('User'))?.token}`,
    })
  }
  verifyToken(){
    console.log(JSON.parse(localStorage.getItem('User'))?.token);
    return this.http.get<any>(`${JSON.parse(localStorage.getItem('User')).synfra_url}/api/tab-console/verify`,{headers:{
        'Content-Type': 'application/json',
        Authorization: `Bearer ${JSON.parse(localStorage.getItem('User'))?.token}`,
      }}).pipe(map((data) => {
      return data;
    })) ;
  }
  GetCurrentEmendamento(){
    return this.http.get<any>(`${JSON.parse(localStorage.getItem('User'))?.synfra_url}/api/tab-console/current?o=${JSON.parse(localStorage.getItem('User'))?.idOrgano}`,
      {headers:{
        'Content-Type': 'application/json',
        Authorization: `Bearer ${JSON.parse(localStorage.getItem('User'))?.token}`,
      }}).pipe(map((data) => {
      return data;
    })) ;
  }
  UpdateEmendamento(val){
    return this.http.post<any>(`${JSON.parse(localStorage.getItem('User'))?.synfra_url}/api/tab-console/update?o=${JSON.parse(localStorage.getItem('User'))?.idOrgano}`,
      JSON.stringify(val),
      {headers:{
          'Content-Type': 'application/json',
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('User'))?.token}`,
        }}).pipe(map((data) => {
      return data;
    })) ;
  }
  GetEmendamento(val){
    return this.http.post<any>(`${JSON.parse(localStorage.getItem('User'))?.synfra_url}/api/tab-console/amendment?o=${JSON.parse(localStorage.getItem('User'))?.idOrgano}`,
      JSON.stringify(val),
      {headers:{
          'Content-Type': 'application/json',
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('User'))?.token}`,
        }}).pipe(map((data) => {
      return data;
    })) ;
  }
}
